import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';

const url = `${PREFIX_URL}/task/projectTaskStatus`;

type CounterCount = {
  count: number;
};

type TaskCounterCount = {
  count: number;
  change_requested: number;
  delay: number;
};

type CountersResponse = {
  new_files: CounterCount;
  task_due: CounterCount;
  task_for_approval: TaskCounterCount;
  task_for_review: TaskCounterCount;
  delayed_task: CounterCount;
};

export const getCounters = (params): Promise<CountersResponse> => {
  return axios.get(url, {
    params: params,
    showError: false,
  });
};

export const counterKeys = {
  list: ['dashboardCounters'] as const,
};

type QueryFnType = typeof getCounters;

type useCountersOptions = {
  projectId: string;
  userId: number;
  userRole: number;
  date: string;
  config?: QueryConfig<QueryFnType>;
};

export const useCounters = ({ projectId, config, ...otherParams }: useCountersOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...counterKeys.list, projectId, otherParams],
    queryFn: () => getCounters({ projectId, ...otherParams }),
    staleTime: Infinity,
    ...config,
  });
};
